<template>
  <div id="app">
    <dashboard>
      <template slot="header">
        <div class="navbar-item btn-download">
          <a
            class="button is-link is-light"
            style="height: 2.2em; font-weight: normal"
            @click="$router.push({ name: 'download' })"
          >
            {{ $l("global.download", "Download") }}
          </a>
        </div>
      </template>

      <template slot="login-right">
        <div class="has-text-centered">
          <a
            class="button is-primary"
            @click="$router.push({ name: 'download' })"
          >
            {{
              $l(
                "components.login.downloadCyES",
                "Download CyRadar Endpoint Security"
              )
            }}
          </a>
        </div>
      </template>
    </dashboard>
  </div>
</template>
<style src="@cyradar/ui/dist/ui.css"></style>
<script>
import { mapGetters } from 'vuex'
import jwt from 'jwt-decode'
import { Input, Icon } from 'iview'

export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'authenticationToken',
      'authenticationClaims',
      'groupList',
      'routes'
    ])
  },

  components: {
    // eslint-disable-next-line vue/no-unused-components
    Input,
    // eslint-disable-next-line vue/no-unused-components
    Icon
  },

  watch: {
    authenticationToken (val, oldVal) {
      if (!val) {
        this.$store.dispatch('AUTHENTICATION_SET_CLAIMS')
        return
      }
      this.$store.dispatch('AUTHENTICATION_SET_CLAIMS', jwt(val))
    },
    authenticationClaims (val, oldVal) {
      if (!val) {
        return
      }
      this.$store.dispatch('RELOAD_GROUP_LIST')
    },
    groupList (list) {
      for (let i = 0; i < list.length; i++) {
        let children = []
        if (list[i].childGroups && list[i].childGroups.length > 0) {
          list[i].children = list.filter((e) =>
            list[i].childGroups.includes(e._id)
          )
          children = list[i].children.map((e) => {
            return {
              path: `/agent/${list[i]._id}/${e._id}`,
              meta: { title: e.name }
            }
          })

          list = list.filter((e) => !list[i].childGroups.includes(e._id))
        }

        const r = {
          path: `/agent/${list[i]._id}`,
          meta: { title: list[i].name },
          children: children
        }

        list[i] = r
        this.$router.addRoute('agent', r)
      }

      this.$store.commit('ROUTE_ADD_CHILDREN', {
        parent: 'agent',
        children: list
      })
    }
  },
  mounted () {
    if (!this.authenticationToken) {
      this.$store.dispatch('AUTHENTICATION_SET_CLAIMS')
      return
    }
    this.$store.dispatch(
      'AUTHENTICATION_SET_CLAIMS',
      jwt(this.authenticationToken)
    )
  }
}
</script>
<style lang="scss">
@import "assets/app.scss";
</style>
